
const Header = () => {
  return (
    <div>
      <header>
        <div className="header-div">
          <img src="assets/images/icon-star.svg" alt="" />
          <h1><abbr title="Frequently Asked Questions">FAQs</abbr></h1>
        </div>
      </header>
    </div>
  )
}

export default Header
